export enum ResizeCropMethodURIs {
  NONE_URI = '',
  FILL_CROP_URI = 'c_fill',
  PAD_URI = 'c_pad',
  FILL_AI_CROP_URI = 'c_fill,g_auto',
}
